<template>
  <section class="video-section">
    <!-- <div id="socialContainer" class="mt-3 socialMt"> -->
    <div id="socialContainer" class="socialMt">
      <button
        id="btnHeart"
        @click="onLike"
        class="typography--b4"
        v-bind:class="{ active: likes }"
      >
        {{ likesCount }}
      </button>
      <button
        id="btnBookmark"
        @click="onBookmark"
        class="typography--b4"
        v-bind:class="{ active: clipping }"
      >
        {{ clippingCount }}
      </button>
    </div>

    <div id="bookmarkIcon" ref="bookmarkIcon">
      <div>
        <img
          v-if="clipping"
          src="../../assets/bookmark-on.svg"
          alt="Bookmark On"
        />
        <img v-else src="../../assets/bookmark.svg" alt="Bookmark Off" />
      </div>
    </div>

    <div id="likeIcon" ref="likeIcon">
      <div>
        <img v-if="likes" src="../../assets/heart-on.svg" alt="Like On" />
        <img v-else src="../../assets/heart.svg" alt="Like Off" />
      </div>
    </div>
  </section>
</template>

<script>
/**
 * 나의 학습 차시 학습창 - 좋아요/북마크 컴포넌트(my learning lesson study - like/bookmark component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import learnApi from "@/api/learnApi.js";
export default {
  props: ["likesCount", "clippingCount", "likes", "clipping"],
  methods: {
    // API 파라미터 설정(set parameter)
    setParams() {
      let params = {
        learnId: this.$route.params.learnId,
        progressionId: this.$route.params.progressionId,
      };
      return params;
    },

    // 좋아요 API 호출(set/cancel like)
    onLike() {
      let params = this.setParams();
      let responseData = null;
      if (this.likes) {
        learnApi
          .learnLessonLikesDelete(params)
          .then((response) => {
            responseData = response.data.data;
            this.$emit("updateLikesCount", {
              likes: responseData,
              likesCount: this.likesCount - 1,
            });
            this.toggleLikeIcon();
          })
          .catch((err) => {});
      } else {
        learnApi
          .learnLessonLikesPost(params)
          .then((response) => {
            responseData = response.data.data;
            this.$emit("updateLikesCount", {
              likes: responseData,
              likesCount: this.likesCount + 1,
            });

            this.toggleLikeIcon();
          })
          .catch((err) => {});
      }
    },

    // 북마크 API 호출(set/cancel bookmark)
    onBookmark() {
      let params = this.setParams();
      let responseData = null;
      if (this.clipping) {
        learnApi
          .learnLessonClippingDelete(params)
          .then((response) => {
            responseData = response.data.data;
            this.$emit("updateBookmarkCount", {
              clipping: responseData,
              clippingCount: this.clippingCount - 1,
            });
            this.toggleBookmarkIcon();
          })
          .catch((err) => {});
      } else {
        learnApi
          .learnLessonClippingPost(params)
          .then((response) => {
            responseData = response.data.data;
            this.$emit("updateBookmarkCount", {
              clipping: responseData,
              clippingCount: this.clippingCount + 1,
            });
            this.toggleBookmarkIcon();
          })
          .catch((err) => {});
      }
    },

    // 좋아요 UI 노출(toggle like icon)
    toggleLikeIcon() {
      const element = this.$refs.likeIcon;
      element.classList.add("fade", "show");
      setTimeout(() => {
        element.classList.add("hide");
        setTimeout(() => {
          element.classList.remove("fade", "show", "hide");
        }, 300);
      }, 1000 + 300);
    },

    // 북마크 UI 노출(toggle bookmark icon)
    toggleBookmarkIcon() {
      const element = this.$refs.bookmarkIcon;
      element.classList.add("fade", "show");
      setTimeout(() => {
        element.classList.add("hide");
        setTimeout(() => {
          element.classList.remove("fade", "show", "hide");
        }, 300);
      }, 1000 + 300);
    },
  },
};
</script>